/**
 * Shared constants for the Term Structure Decomposition tab.
 *
 * Kept in a non-component module so `DecompositionTab.tsx` only exports
 * components (required for React Fast Refresh).
 */

/** Short legend names to prevent text cutoff.
 *  Shared so the detail modal can render the same shortenings. */
export const DECOMPOSITION_SHORT_NAMES: Record<string, string> = {
  'Real Risk-Free Rate': 'Real RF Rate',
  'Stock Excess Return': 'Stock XS',
  'Bond Excess Return': 'Bond XS',
  'Commodity Excess Return': 'Cmdty XS',
  'Swap Excess Return': 'Swap XS',
  'Price-Dividend Ratio': 'P/D Ratio',
  'Dividend Growth': 'Div Growth',
  'Term Spread': 'Term Spread',
  'Commodity Carry': 'Cmdty Carry',
  'Commodity Price': 'Cmdty Price',
  'Swap Rate': 'Swap Rate',
  'Credit Spread': 'Credit Sprd',
  Inflation: 'Inflation',
  'Real GDP': 'Real GDP',
  'Inflation Cycle': 'Infl Cycle',
  'Total Change': 'Total Chg',
};
